import { render } from "./aiFrame.vue?vue&type=template&id=4996d674&scoped=true"
import script from "./aiFrame.vue?vue&type=script&lang=js"
export * from "./aiFrame.vue?vue&type=script&lang=js"

import "./aiFrame.vue?vue&type=style&index=0&id=4996d674&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4996d674"]])

export default __exports__